export const headerData = [
					{
						title:'政府版',
						url:'https://v1.mzipatent.com/#/login?version=zfb'
					},
					{
						title:'园区版',
						url:'https://v1.mzipatent.com/#/login?version=yqb'
					},
					{
						title:'高校版',
						url:'https://v1.mzipatent.com/#/login?version=gxb'
					},
					{
						title:'科研院所版',
						url:'https://v1.mzipatent.com/#/login?version=kyysb'
					},
					{
						title:'企业版',
						url:'https://v1.mzipatent.com/#/login?version=qyb'
					}
				]


// WEBPACK FOOTER //
// ./src/view/data/header.js